module.exports = __webpack_public_path__ + "67e2fd90daa336ef559cd5651de537fc.png";